import { Sparkle } from "lucide-react";
import { BRAND } from "@/data/site";

const ITEMS = [
  "Clean Surfaces",
  "Better Health",
  "Brighter Spaces",
  BRAND.phone,
  "Residential & Commercial",
  "Free Estimates",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-cyan-400/15 bg-[#060f26] py-5" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display font-black italic uppercase text-2xl sm:text-3xl tracking-tight text-white/90 px-6">
                  {item}
                </span>
                <Sparkle className="w-4 h-4 text-cyan-400 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
